/**
 * Work Center Selector
 *
 * Multi-select toggles for work centers.
 * Shows count badges for pending items.
 */

export default function WorkCenterSelector({
  workCenters,
  selected,
  counts,
  onToggle,
}) {
  return (
    <div className="px-4 pb-3">
      <div className="flex gap-2 overflow-x-auto">
        {workCenters.map((wc) => {
          const isSelected = selected.includes(wc.id);
          const count = counts[wc.id] || 0;

          return (
            <button
              key={wc.id}
              onClick={() => onToggle(wc.id)}
              className={`relative px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${
                isSelected
                  ? "bg-white text-indigo-700"
                  : "bg-slate-100 text-gray-900 hover:bg-gray-200"
              }`}
            >
              {wc.label}
              {count > 0 && (
                <span
                  className={`absolute -top-1 -right-1 min-w-[18px] h-[18px] flex items-center justify-center text-[10px] font-bold rounded-full ${
                    isSelected
                      ? "bg-indigo-600 text-gray-900"
                      : "bg-yellow-500 text-black"
                  }`}
                >
                  {count > 99 ? "99+" : count}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
